export const toGlobalId = (type, id) => (type && id ? btoa(`${type}:${id}`) : null);
